"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monte-isola": {
    "b2fa7a1f": [{
      "hkey": "38fd5b44",
      "slug": "menzino-sinchignano",
      "name": "Menzino-Sinchignano",
      "primary": true,
      "skipSearch": false
    }],
    "menzino": [{
      "hkey": "38fd5b44",
      "slug": "menzino-sinchignano",
      "name": "Menzino-Sinchignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1468060d": [{
      "hkey": "46008b7a",
      "slug": "sensole-senzano",
      "name": "Sensole-Senzano",
      "primary": true,
      "skipSearch": false
    }],
    "sensole": [{
      "hkey": "46008b7a",
      "slug": "sensole-senzano",
      "name": "Sensole-Senzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b29fd009": [{
      "hkey": "46008b7a",
      "slug": "sensole-senzano",
      "name": "Sensole-Senzano",
      "primary": true,
      "skipSearch": false
    }],
    "senzano": [{
      "hkey": "46008b7a",
      "slug": "sensole-senzano",
      "name": "Sensole-Senzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monte-isola"
    }],
    "530193e9": [{
      "hkey": "38fd5b44",
      "slug": "menzino-sinchignano",
      "name": "Menzino-Sinchignano",
      "primary": true,
      "skipSearch": false
    }],
    "manzino-sinchignano": [{
      "hkey": "38fd5b44",
      "slug": "menzino-sinchignano",
      "name": "Menzino-Sinchignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;